import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ModalForm } from 'src/components/form/form/ModalForm';

import { useInsertScimDomain } from '@/hooks/mutations/scim/useInsertScimDomain';

import ScimDomainForm from './forms/ScimDomainForm';
import type { ScimDomainFormFields } from './forms/ScimDomainFormSchema';
import {
  defaultValues,
  ScimDomainFormSchema,
} from './forms/ScimDomainFormSchema';

type Props = {
  onDismiss: () => void;
};

const ScimDomainModal: FC<Props> = ({ onDismiss }) => {
  const { t } = useTranslation();

  const { insertScimDomain } = useInsertScimDomain();

  const onSave = async (values: ScimDomainFormFields) => {
    const { domain } = values;
    await insertScimDomain({ domain });
  };

  return (
    <ModalForm
      i18n={t('authenticationSettings')}
      defaultValues={defaultValues}
      schema={ScimDomainFormSchema}
      onSave={onSave}
      onDismiss={onDismiss}
      formId={'scim-domain-form'}
      visible={true}
    >
      <ScimDomainForm />
    </ModalForm>
  );
};

export default ScimDomainModal;
